import styled from 'styled-components';

export default styled.section`
  background: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.shadows.low};
  border-radius: 4px;
  width: 100%;
  display: inline-block;
  padding: 1.875rem 1.375rem 2.3125rem;
  box-sizing: border-box;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    padding: 1.75rem 2.0625rem 2.375rem;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 1.875rem 1.875rem 2.3125rem;
    max-width: ${props => props.theme.maxWidths.cardCoupon};
  }

  > * {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
